const sliderrr = document.querySelector('.shop-products');

if (sliderrr){

let isDown = false;
let startX;
let scrollLeft;

let velocity = 0;
let lastX = 0;
let momentumID;

sliderrr.addEventListener('mousedown', (e) => {
  e.preventDefault();
  isDown = true;
  startX = e.pageX;
  scrollLeft = sliderrr.scrollLeft;
  lastX = startX;
  velocity = 0;

  cancelAnimationFrame(momentumID);
  sliderrr.style.cursor = 'grabbing';
});

sliderrr.addEventListener('mousemove', (e) => {
  if (!isDown) return;

  const x = e.pageX;
  const walk = x - startX;

  sliderrr.scrollLeft = scrollLeft - walk;

  velocity = x - lastX;   // speed capture
  lastX = x;
});

function momentumScroll() {
  sliderrr.scrollLeft -= velocity;
  velocity *= 0.95; // friction (lower = more smooth, higher = more distance)

  if (Math.abs(velocity) > 0.5) {
    momentumID = requestAnimationFrame(momentumScroll);
  }
}

sliderrr.addEventListener('mouseup', () => {
  isDown = false;
  sliderrr.style.cursor = 'grab';
  momentumScroll();
});

sliderrr.addEventListener('mouseleave', () => {
  if (!isDown) return;
  isDown = false;
  sliderrr.style.cursor = 'grab';
  momentumScroll();
});
}